import { Modal as bsModal } from 'bootstrap';

// There has to be a nicer way of doing this..?
let production = document.URL == "https://riat-web-01.azurewebsites.net" || document.URL.includes("airtattoo.com");
let seatmapBaseUrl = production ? "https://seatmap.vivenu.com" : "https://seatmap.vivenu.dev";

const invalidSeatSelection = "You have invalid seat selections.";
const viewOnlyMode = "ViewOnly";
// ******************************
// *****  Vivenu callbacks  *****
// ******************************

function getSeatTicketOptions(plan, pageId, eventId, seatingEventId, type, id, resource, modelMode) {
    //console.log("Function getSeatTicketOptions");
    //console.log("Type: " + type);
    //console.log("Id: " + id);
    //console.log(resource);

    const getTicketList = `/Umbraco/Surface/SeatMap/GetTicketList?pageId=${pageId}&eventId=${eventId}&seatingEventId=${seatingEventId}&type=${type}&id=${id}&resource=${JSON.stringify(resource)}&mode=${modelMode}`;
    openSeatModal(plan, getTicketList);
}

function assignSeatTicket(plan, eventId, ticketTypeId, seatingEventId, id, statusId, modelMode) {
    //console.log("Function seatSelected");
    //console.log("EventId: " + eventId);
    //console.log("TicketTypeId:" + ticketTypeId);
    //console.log("seatingEventId: " + seatingEventId);
    //console.log("id: " + id);
    //console.log("modelMode: " + modelMode);
    //console.log("statusId: " + statusId);

    const endpoint = `/Umbraco/Surface/SeatMap/AddSeatSelection?eventId=${eventId}&ticketId=${id}&ticketTypeId=${ticketTypeId}&seatingEventId=${seatingEventId}&statusId=${statusId}&mode=${modelMode}`;
    
    fetch(endpoint, {
        method: 'POST'
    }).then(function (response) {
        if (response.ok) {
            return response.text();
        }
        return Promise.reject(response);
    }).then(function (result) {
        var seatList = document.getElementById("selected-seats-" + seatingEventId);
        if (seatList) {
            //console.info("Seat list html:", result);
            seatList.innerHTML = result;        
            plan.selections.push(id);
        }
        //console.log(`seat ${id} added`);
    }).catch(function (err) {
        console.warn('Something went wrong.', err);
    }).finally(function () {
        //console.log("Seat selected finally");
        validateSelection(plan);
        plan.instance.selectObjectsInSeatSelector(plan.selections);
        const overlay = document.querySelector('.modal-overlay');
        overlay.style.display = "none";
    });
}

function seatDeselected(plan, eventId, seatingEventId, type, id, resource, modelMode) {
    //console.log("Function seatDeselected");
    //console.log("Type: " + type);
    //console.log("Id: " + id);
    //console.log(resource);

    const endpoint = `/Umbraco/Surface/SeatMap/RemoveSeatSelection?eventId=${eventId}&seatingEventId=${seatingEventId}&type=${type}&id=${id}&resource=${JSON.stringify(resource)}&mode=${modelMode}`;

    fetch(endpoint, {
        method: 'POST'
    }).then(function (response) {
        if (response.ok) {
            return response.text();
        }
        return Promise.reject(response);
    }).then(function (result) {
        var seatList = document.getElementById("selected-seats-" + seatingEventId);
        if (seatList) {
            //console.info("Seat list html:", result);
            seatList.innerHTML = result;
            //console.log(`seat ${id} removed`);
            plan.selections = plan.selections.filter(s => s !== id);
        }
        //console.log(`seat ${id} removed`);
    }).catch(function (err) {
        console.warn('Something went wrong.', err);
    }).finally(function () {
        //console.log("Seat deselected finally");
        validateSelection(plan);
        plan.instance.selectObjectsInSeatSelector(plan.selections);
        const overlay = document.querySelector('.modal-overlay');
        overlay.style.display = "none";
    });
};

function mapLoadDone(plan, type) {
    console.log("Function mapLoadDone");
    console.log("loading is done");
}

function validateSelection(plan) {
    const continueButton = document.querySelector("#update-basket-form button[type='submit']") || document.querySelector("#seating-map button[type='submit']");
    if (plan.violations.length === 0 && plan.selections.length > 0) {
        continueButton.removeAttribute('disabled');
    } else {
        continueButton.setAttribute('disabled', 'disabled');
    }
}

// *********************************
// *****  modal functionality  *****
// *********************************

var seatModal = null,
seatModalContentWrapper = null;

const loadingHTML = '<div class="package-options-modal--header"><h1 class="h3 m-0"><i class="fa-regular fa-sync fa-fw fa-spin"></i> Loading...</h1></div>';

// Function to load modal content
async function getModalContent(contentURL) {
    let detailHTML = await (await window.fetch(contentURL, {
        method: 'GET'
    })).text();
    return detailHTML;
}

const openSeatModal = (plan, contentURL) => {
    if(seatModal) {
        // set loading content
        seatModalContentWrapper.innerHTML = loadingHTML;
        // open modal
        seatModal.show();
        // get content and update modal div html
        if (contentURL && contentURL.length > 0) {
            getModalContent(contentURL).then((newHTML) => {
                seatModalContentWrapper.innerHTML = newHTML;
                // find each button and create click listener
                seatModalContentWrapper.querySelectorAll('button').forEach(b => {
                    let eventId = b.dataset.eventId,
                        ticketTypeId = b.dataset.ticketTypeId,
                        seatingEventId = b.dataset.seatingEventId,
                        id = b.dataset.id,
                        statusId = b.dataset.statusId,
                        modelMode = b.dataset.mode;
                    b.addEventListener('click', () => {
                        assignSeatTicket(plan, eventId, ticketTypeId, seatingEventId, id, statusId, modelMode);
                        seatModalContentWrapper.innerHTML = loadingHTML;
                        closeSeatModal();
                    });
                })
            });
        }
    }
};

const closeSeatModal = () => {
    if (seatModal) seatModal.hide();
    const overlay = document.querySelector('.modal-overlay');
    overlay.style.display = "none";
}


// ************************
// *****  plan class  *****
// ************************
class Plan {

    constructor(el, index) {
        this.plan = this;
        this.el = el;
        this.index = index;
        this.data = window.seatSelectorData[this.index];
        this.seatListEl = document.getElementById("selected-seats-" + this.data.seatingEventId);
        this.seatCount = 0;
        this.currentSelection = {};
        this.selections = [];
        this.violations = [];
        // create instance in Vivenu js
        this.instance = VIInit();

        this.instance.initSeatSelector({
            holder: `map-${this.data.eventId}`,
            baseUrl: seatmapBaseUrl,
            eventId: this.data.seatingEventId,
            options: this.data.options,
            callbacks: {
                onObjectSelected: (type, id, resource) => {
                    if (this.data.modelMode === viewOnlyMode) {
                        this.instance.selectObjectsInSeatSelector(this.selections);
                        return false;
                    }
                    //getSeatTicketOptions(this.data.pageId, this.data.eventId, this.data.seatingEventId, type, id, resource, this.data.modelMode);
                    console.info("onObjectSelected", resource);
                    this.currentSelection.type = type;
                    this.currentSelection.id = id;
                    this.currentSelection.resource = resource;
                    console.info("onObjectSelected", this.selections);
                    if (this.seatCount > 0 && this.seatCount === this.selections.length) {
                        this.instance.selectObjectsInSeatSelector(this.selections);
                        alert(`You may only select ${this.seatCount} seats`);
                    }
                    else {
                        const overlay = document.querySelector('.modal-overlay');
                        overlay.style.display = "block";

                        getSeatTicketOptions(
                            this.plan,
                            this.data.pageId,
                            this.data.eventId,
                            this.data.seatingEventId,
                            this.currentSelection.type,
                            this.currentSelection.id,
                            this.currentSelection.resource,
                            this.data.modelMode);
                    }
                },
                onObjectDeselected: (type, id, resource) => {
                    if (this.data.modelMode === viewOnlyMode) return false;
                    const overlay = document.querySelector('.modal-overlay');
                    overlay.style.display = "block";

                    seatDeselected(this.plan, this.data.eventId, this.data.seatingEventId, type, id, resource, this.data.modelMode);
                    //console.info("onObjectDeselected", this.selections);
                },
                onSelectionValid: (type) => {
                    if (this.data.modelMode === viewOnlyMode) return false;
                    this.violations = [];
                },
                onSelectionInvalid: (type, violations) => {
                    if (this.data.modelMode === viewOnlyMode) return false;
                    this.violations = violations || [];
                },
                onLoadDone: (type) => {
                    if (this.data.modelMode !== viewOnlyMode) {
                        this.selections = JSON.parse(this.seatListEl.dataset.selections);
                        this.seatCount = parseInt(this.seatListEl.dataset.seatCount);
                        if (this.selections.length > 0) {
                            this.instance.selectObjectsInSeatSelector(this.selections);
                        }
                    }
                    mapLoadDone(this.plan, type);
                }
            }
        });
    }
}

// ***************************
// *****  set things up  *****
// ***************************

let s = document.createElement('script');
s.type = 'text/javascript';
s.src = seatmapBaseUrl + '/js/init.js';
s.async = true;
document.head.appendChild(s);
s.addEventListener('load', () => {

    // find wrapper
    const wrapper = document.querySelector('.js-seating-plan');

    // find modal
    let findModal = document.querySelector('#js-seating-plan--modal');
    if (!findModal) {
        // add modal HTML to page
        let m = document.createElement('DIV');
        m.setAttribute('id','js-seating-plan--modal');
        m.setAttribute('data-bs-backdrop','static');
        m.setAttribute('data-bs-keyboard','false');
        m.setAttribute('tabindex','-1');
        m.setAttribute('role','dialog');
        m.setAttribute('aria-label','Seat Tickets modal');
        m.setAttribute('aria-hidden','true');
        m.classList.add('modal','fade');
        m.innerHTML = '<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document"><div class="modal-content"><div class="modal-header"><h1 class="h3">Please select an option:</h1><button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button></div><div class="modal-body p-0"><div class="panel-padding theme--white"><div id="js-seating-plan--modal--content-wrapper"></div></div></div></div></div>';
        document.body.appendChild(m);
        // find again
        findModal = m;
    }
    if (findModal != null) {
        seatModal = bsModal.getOrCreateInstance(findModal);
        findModal.querySelector('button.btn-close').addEventListener('click', () => { closeSeatModal(); });
        seatModalContentWrapper = findModal.querySelector('#js-seating-plan--modal--content-wrapper');
        // clear modal content when it closes
        findModal.addEventListener('hidden.bs.modal', () => {
            seatModalContentWrapper.innerHTML = '';
        });
    }

    // set up all the instances in the page
    wrapper.querySelectorAll('.js-seating-plan--instance').forEach((p, i) => {
        new Plan(p,i);
    });

});
